// extracted by mini-css-extract-plugin
export default {"variantsWrapper":"Cs5Vc","variant":"Q1Oeg"};